<template>
  <div class="time-select">
    <div class="title" @click="handleClick">{{ label }}</div>
    <i class="icon-calendar-2-line t-iconfont" @click="drawer = true"></i>
  </div>
  <van-calendar
    v-model:show="drawer"
    allow-same-day
    :default-date="defaultRange"
    :max-date="today"
    :max-range="isLimit ? 31 : 365"
    :min-date="minDate"
    switch-mode="none"
    teleport="body"
    type="range"
    @confirm="onConfirm"
  />
</template>

<script setup>
import { ref, onMounted } from 'vue'

const props = defineProps({
  value: {
    type: Array,
    default: () => []
  },
  isLimit: {
    type: Boolean,
    default: true
  },
  label: {
    type: String,
    default: '选择会话时间'
  }
})

const emits = defineEmits(['update:value', 'dateChange'])

const drawer = ref(false)
const today = ref(new Date())
const minDate = ref(new Date())
const defaultRange = ref([])

const onConfirm = (values) => {
  const [start, end] = values
  drawer.value = false
  emits('update:value', [Date.parse(start), Date.parse(end)])
  emits('dateChange')
}

const handleClick = () => {
  drawer.value = true
}

onMounted(() => {
  minDate.value.setFullYear(today.value.getFullYear() - 3)
  const [start = new Date().getTime(), end = new Date().getTime()] = props.value
  defaultRange.value = [new Date(start), new Date(end)]
})
</script>

<style lang="scss" scoped>
.time-select {
  flex: 0 0 auto;
  width: 132px;
  padding: 8px 12px;
  border-radius: 8px;
  background: #f7f8fa;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-family: PingFang SC;
  font-size: 14px;
  line-height: 20px;
  color: #323233;
  .title {
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  :deep(.el-drawer) {
    border-radius: 20px 20px 0px 0px;
  }
  .drawer-content {
    display: flex;
    flex-direction: column;
    height: 100%;
    position: relative;
    .left {
      flex: 0 0 52px;
    }
    .right {
      flex: 0 0 52px;
      text-align: right;
      color: #969799;
      font-size: 20px;
    }
    .head {
      flex: 0 0 auto;
      overflow: hidden;
      text-align: center;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 13px 16px;
      /* 三级文字/常规 */
      font-family: PingFang SC;
      font-size: 16px;
      line-height: 22px;

      color: #323233;
    }
    .content {
      flex: 1;
      overflow: hidden;
    }
  }
}
</style>
